.typeBar { display: flex; flex-wrap: wrap; gap: 6px; }
.dTbl td { height: 56px; padding: 0 12px; overflow: hidden; text-overflow: ellipsis; }
.dTbl th { padding: 0 12px; }
.dTbl td b { font-weight: var(--fw-label); }
.dTbl td > div { font-size: 12px; color: var(--lb); }
.locked { color: var(--lb); }
.locked > span { display: inline-flex; align-items: center; gap: 4px; }
.after { color: var(--tx2); }
.empty { padding: 32px; text-align: center; color: var(--lb); }
.bar { flex-wrap: wrap; }
.typeBar { flex: 1 1 100%; order: 2; }

.dock { display: flex; flex-direction: column; gap: 12px; box-sizing: border-box; padding: 18px 16px; overflow-y: auto; scrollbar-width: thin; background: var(--card); }
.dock h2 { margin: 0; font-size: 16px; font-weight: 600; }
.h2b { margin-top: 8px !important; }
.cap { font-size: 12px; color: var(--lb); }
.tpl { display: flex; align-items: center; gap: 10px; min-height: 44px; border-top: 1px solid var(--line); }
.tpl > div { flex-grow: 1; min-width: 0; }
.tpl b, .soon b { font-weight: var(--fw-label); }
.tpl > div > div, .soon > div { font-size: 12px; color: var(--lb); }
.link { display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: 0; background: transparent; font: inherit; font-weight: var(--fw-label); color: var(--link); cursor: pointer; }
.soon { padding: 8px 0; border-top: 1px solid var(--line); }

.soonCard { display: flex; flex-direction: column; gap: 4px; padding: 10px 12px; border-radius: 12px; background: var(--sub); }
.soonCard > div { display: flex; justify-content: space-between; }
.soonCard b { font-weight: var(--fw-label); }
.soonCard > div > span { font-size: 12px; color: var(--warn); font-weight: var(--fw-label); }
.soonCard > span { font-size: 12px; color: var(--tx2); }
.soonCard > button { align-self: flex-start; }
.draftNote { padding: 10px 12px; border-radius: 12px; background: var(--warn-bg); color: var(--warn); font-size: 12px; font-weight: var(--fw-label); }
.note { font-size: 12px; color: var(--lb); }
.h3 { margin-top: 6px; font-weight: 600; }
